﻿(function () {
    "use strict";

    angular.module("app").controller("VendorsController", VendorsController);

    VendorsController.$inject = [];

    function VendorsController() {
        var vm = this;
    }
})();
